"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _SvgIcon = _interopRequireDefault(require("./SvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Asterisk = function Asterisk(_ref) {
  var size = _ref.size,
      color = _ref.color;
  return _react["default"].createElement(_SvgIcon["default"], {
    title: "asterisk",
    size: size
  }, _react["default"].createElement("path", {
    fill: color,
    d: "M4.46 3.55l1.59-.66a.69.69 0 01.93.46.7.7 0 01-.59.87l-1.7.24L5.76 5.9a.7.7 0 01-.2 1.02.67.67 0 01-.97-.33L4 5.18l-.58 1.4a.67.67 0 01-.96.33.7.7 0 01-.2-1.02L3.3 4.46l-1.7-.24a.7.7 0 01-.58-.87.69.69 0 01.93-.46l1.59.66-.22-1.79a.68.68 0 111.36 0l-.22 1.79z"
  }));
};

Asterisk.defaultProps = {
  size: 8,
  color: '#444'
};
var _default = Asterisk;
exports["default"] = _default;